var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusFeedbackRuim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 41.25C32.8553 41.25 41.25 32.8553 41.25 22.5C41.25 12.1447 32.8553 3.75 22.5 3.75C12.1447 3.75 3.75 12.1447 3.75 22.5C3.75 32.8553 12.1447 41.25 22.5 41.25Z",
    stroke: "#DE0000",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 31.875C18.4695 30.6932 20.4086 30 22.5 30C24.5914 30 26.5305 30.6932 28.125 31.875",
    stroke: "#DE0000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 22.5C29.1605 22.5 30 21.2408 30 19.6875C30 18.1342 29.1605 16.875 28.125 16.875C27.0895 16.875 26.25 18.1342 26.25 19.6875C26.25 21.2408 27.0895 22.5 28.125 22.5Z",
    fill: "#DE0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 22.5C17.9105 22.5 18.75 21.2408 18.75 19.6875C18.75 18.1342 17.9105 16.875 16.875 16.875C15.8395 16.875 15 18.1342 15 19.6875C15 21.2408 15.8395 22.5 16.875 22.5Z",
    fill: "#DE0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFeedbackRuim);
export default __webpack_public_path__ + "static/media/statusFeedbackRuim.6592fb7f4de30c25b6cc50c415c9820a.svg";
export { ForwardRef as ReactComponent };